import { render } from "./dingdanList.vue?vue&type=template&id=bea93b30&scoped=true"
import script from "./dingdanList.vue?vue&type=script&lang=js"
export * from "./dingdanList.vue?vue&type=script&lang=js"

import "./dingdanList.vue?vue&type=style&index=0&id=bea93b30&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bea93b30"

export default script